
import { ref } from '@nuxtjs/composition-api';

export default {
  name: 'TlmCountDown',
  props: {
    end: {
      type: String,
      default: ''
    },
    timerText: {
      type: String,
      default: 'Tilbuddet slutter om '
    }
  },
  setup(props) {
    const remainingTime = ref(null)
    const expired = ref(false)

    // format number with 2 digits
    const pad = (d) => (d < 10) ? '0' + d.toString() : d.toString();

    // basic countdown
    const countdown = (end) => {
      // bails if expired
      if (expired.value) { return }

      const now = new Date()
      const endDate = new Date(end)
      const distance = endDate.getTime() - now.getTime()
      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = pad(Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      ))
      const minutes = pad(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)))
      const seconds = pad(Math.floor((distance % (1000 * 60)) / 1000))

      if (distance <= 0) {
        expired.value = true
        clearInterval(interval)
      }

      return {
        days,
        hours,
        minutes,
        seconds
      }
    }

    const interval = setInterval(() => {
      remainingTime.value = countdown(props.end)
    }, 1000)

    remainingTime.value = countdown(props.end)

    return {
      countdown,
      remainingTime,
      expired
    }
  }
}
